<div class="simulation-card block rounded-xl transition-shadow" (click)="open.emit()">
<p-card>
  <ng-template #title>
    <div class="flex items-center justify-between gap-2">
      <span class="truncate">
        @if (simulation().name) {
          {{ simulation().name }}
        } @else {
          {{ elementLabel(simulation().elementType) | translate }} {{ simulation().geometry?.thickness_m }}m
        }
      </span>
      <p-button
        [icon]="favouritePending() ? 'fa-solid fa-spinner fa-spin' : (simulation().favourite ? 'fa-solid fa-star' : 'fa-regular fa-star')"
        [disabled]="favouritePending()"
        [styleClass]="'p-button-sm p-button-text' + (simulation().favourite ? ' text-yellow-500' : '')"
        [pTooltip]="(simulation().favourite ? 'simulator.history.unfavourite' : 'simulator.history.favourite') | translate"
        (click)="$event.stopPropagation(); favouriteToggled.emit()">
      </p-button>
    </div>
  </ng-template>
  <ng-template #subtitle>{{ simulation().pourDate | date:'dd/MM/yyyy' }}</ng-template>

  <div class="flex items-center gap-2 mb-3">
    @if (riskSeverity(); as severity) {
      <p-tag [severity]="severity" [value]="('simulator.history.risk-prefix' | translate) + (riskLabel(simulation().results?.overallCrackingRisk) | translate)"></p-tag>
    }
  </div>

  <div class="flex items-start gap-3 py-2">
    <div class="w-8 flex justify-center text-surface-400 mt-0.5 flex-shrink-0">
      <i class="fa-solid fa-flask text-sm"></i>
    </div>
    <div class="flex flex-col gap-0.5">
      <div class="text-sm font-medium text-surface-900 dark:text-surface-0">
        {{ mixtureLabel(simulation()) || ('simulator.history.custom' | translate) }}
      </div>
      <div class="text-xs text-surface-500 dark:text-surface-400">{{ 'simulator.history.col-mixture' | translate }}</div>
    </div>
  </div>

  <div class="flex items-start gap-3 py-2">
    <div class="w-8 flex justify-center text-surface-400 mt-0.5 flex-shrink-0">
      <i class="fa-solid fa-temperature-high text-sm"></i>
    </div>
    <div class="flex flex-col gap-0.5">
      <div class="text-sm font-medium text-surface-900 dark:text-surface-0">
        {{ simulation().results?.peakCoreTempC | number:'1.1-1' }}°C
      </div>
      <div class="text-xs text-surface-500 dark:text-surface-400">{{ 'simulator.history.col-peak' | translate }}</div>
    </div>
  </div>

  <ng-template #footer>
    <div class="flex gap-4 mt-2" (click)="$event.stopPropagation()">
      <button pButton [outlined]="true" class="w-full" (click)="open.emit()">
        <i class="fa-solid fa-eye mr-2"></i>{{ 'button.open' | translate }}
      </button>
    </div>
  </ng-template>
</p-card>
</div>
